import {
  arrayOptional,
  boolean,
  guidRequired,
  labeled,
  stringOptional,
  stringRequired,
  custom
} from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    planingToRetire: arrayOptional(
      Joi,
      Joi.object().keys({
        idContact: guidRequired(Joi),
        ageToRetire: stringOptional(Joi, 1, 3)
      })
    )
      .has(
        Joi.object().keys({
          idContact: guidRequired(Joi),
          ageToRetire: stringRequired(Joi, 1, 3)
        })
      )
      .required()
      .messages({
        'array.hasKnown': '{{#label}} At least one applicant must be selected.',
        'array.hasUnknown': '{{#label}} At least one applicant must be selected.',
        'array.required': '{{#label}} At least one applicant must be selected.'
      })
      .label(labeled(label, 'At what age is the applicant(s) planning to retire?.')),
    applicantsProposeToRepayLoan: custom(Joi)
      .object()
      .keys({
        coApplicantsIncome: boolean(Joi),
        downsizingHome: boolean(Joi),
        incomeFromOtherInvestments: boolean(Joi),
        other: boolean(Joi),
        recurringIncomeFromSuperAnnuation: boolean(Joi),
        recurringIncomeFromSuperannuation: boolean(Joi),
        repaymentOfLoanPriorToRetirement: boolean(Joi),
        saleOfAssets: boolean(Joi),
        savings: boolean(Joi),
        superAnnuationLumpSumFollowingRetirement: boolean(Joi)
      })
      .orValue(
        'coApplicantsIncome',
        'downsizingHome',
        'incomeFromOtherInvestments',
        'other',
        'recurringIncomeFromSuperAnnuation',
        'recurringIncomeFromSuperannuation',
        'repaymentOfLoanPriorToRetirement',
        'saleOfAssets',
        'savings',
        'superAnnuationLumpSumFollowingRetirement'
      )
      .label(labeled(label, 'How would the applicant(s) propose to repay the loan?'))
      .when('.other', {
        is: true,
        then: Joi.object().keys({
          otherComments: Joi.string()
            .required()
            .label(
              labeled(
                label,
                'How would the applicant(s) propose to repay the loan? - Other details'
              )
            )
        })
      })
  });

export default {
  schema
};
